const VIEWABLE_MIMES = ['application/pdf']
const VIEWABLE_TYPES = ['image', 'audio', 'video']

export const canView = (media: Media) => {
  const { mime, type } = media
  return VIEWABLE_MIMES.includes(mime) || VIEWABLE_TYPES.includes(type)
}
